/* istanbul ignore file */

import { useState } from 'react';

export const useTouch = () => {
    const [activeTab, setActiveTab] = useState<string | null>(null);

    const handleTouch = (id: string) => {
        setActiveTab(prev => (prev === id ? null : id));
    };

    return { handleTouch, activeTab };
};
